import React from 'react';
import {
  RiArrowLeftLine,
  RiQuestionLine,
  RiTruckLine,
  RiNavigationLine,
  RiArchiveLine,
  RiErrorWarningLine,     // ← replaced RiAlertTriangleLine (does not exist)
  RiPhoneLine
} from 'react-icons/ri';

import './DeliveryDetail.css';

const DeliveryDetail = () => {
  const timeline = [
    {
      status: 'Picked Up',
      time: 'Today, 9:00 AM • Warehouse',
      icon: RiArchiveLine,
      bg: 'rgba(203, 227, 195, 1)',
      completed: true,
    },
    {
      status: 'In Transit',
      time: 'Today, 1:30 PM • Distribution Center',
      icon: RiNavigationLine,
      bg: 'rgba(139, 126, 111, 1)',
      completed: true,
    },
    {
      status: 'Out for Delivery',
      time: 'Today, 2:15 PM • Midtown Hub',
      icon: RiTruckLine,
      bg: 'rgba(139, 126, 111, 1)',
      completed: false,
      current: true,
    },
  ];

  return (
    <div className="delivery-detail-page">
      <header className="mobile-header">
        <button className="back-btn">
          <RiArrowLeftLine size={20} />
        </button>
        <div className="header-info">
          <div className="small-text">#2 of 12</div>
          <div className="order-number">Order #DL-4782</div>
        </div>
        <button className="help-btn">
          <RiQuestionLine size={20} />
        </button>
      </header>

      <main className="delivery-content">
        <section className="customer-info">
          <h2>Robert Kim</h2>
          <p className="address">
            789 Cedar Lane, Northside<br />
            Apartment 3C
          </p>
          <div className="delivery-window">
            <span className="label">Window:</span> 1:00 PM – 5:00 PM
          </div>
          <div className="package-count">
            <span className="label">Packages:</span> 4
          </div>
        </section>

        <section className="timeline-section">
          <h3>Delivery Progress</h3>
          <div className="timeline">
            {timeline.map((item, index) => (
              <div
                key={index}
                className={`timeline-step ${item.completed ? 'completed' : ''} ${
                  item.current ? 'current' : ''
                }`}
              >
                <div className="step-icon" style={{ backgroundColor: item.bg }}>
                  <item.icon size={14} color="white" />
                </div>
                <div className="step-details">
                  <div className="step-title">{item.status}</div>
                  <div className="step-time">{item.time}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="actions-section">
          <h3>Need Help?</h3>
          <div className="action-buttons">
            <button className="action-btn problem">
              <RiErrorWarningLine size={16} />    {/* ← updated here */}
              Report Problem
            </button>
            <button className="action-btn">
              <RiPhoneLine size={16} />
              Contact Dispatch
            </button>
          </div>
          <button className="emergency-btn">
            <RiErrorWarningLine size={16} />      {/* ← updated here too */}
            Emergency Contact
          </button>
        </section>

        <section className="notes-section">
          <h3>Delivery Notes</h3>
          <p className="notes">
            Customer prefers front porch drop-off. Gate code: 4729. Please knock twice.
          </p>
        </section>
      </main>
    </div>
  );
};

export default DeliveryDetail;

// import React from 'react';
// import { RiArrowLeftLine, RiHelpCircleLine, RiTruckLine, RiNavigationLine, RiPackageLine, RiAlertTriangleLine, RiPhoneLine } from 'react-icons/ri';
// import './DeliveryDetail.css';

// const DeliveryDetail = () => {
//   const timeline = [
//     {
//       status: 'Picked Up',
//       time: 'Today, 9:00 AM • Warehouse',
//       icon: RiPackageLine,
//       bg: 'rgba(203, 227, 195, 1)',
//       completed: true,
//     },
//     {
//       status: 'In Transit',
//       time: 'Today, 1:30 PM • Distribution Center',
//       icon: RiNavigationLine,
//       bg: 'rgba(139, 126, 111, 1)',
//       completed: true,
//     },
//     {
//       status: 'Out for Delivery',
//       time: 'Today, 2:15 PM • Midtown Hub',
//       icon: RiTruckLine,
//       bg: 'rgba(139, 126, 111, 1)',
//       completed: false,
//       current: true,
//     },
//   ];

//   return (
//     <div className="delivery-detail-page">
//       <header className="mobile-header">
//         <button className="back-btn">
//           <RiArrowLeftLine size={20} />
//         </button>
//         <div className="header-info">
//           <div className="small-text">#2 of 12</div>
//           <div className="order-number">Order #DL-4782</div>
//         </div>
//         <button className="help-btn">
//           <RiHelpCircleLine size={20} />
//         </button>
//       </header>

//       <main className="delivery-content">
//         <section className="customer-info">
//           <h2>Robert Kim</h2>
//           <p className="address">
//             789 Cedar Lane, Northside<br />
//             Apartment 3C
//           </p>
//           <div className="delivery-window">
//             <span className="label">Window:</span> 1:00 PM – 5:00 PM
//           </div>
//           <div className="package-count">
//             <span className="label">Packages:</span> 4
//           </div>
//         </section>

//         <section className="timeline-section">
//           <h3>Delivery Progress</h3>
//           <div className="timeline">
//             {timeline.map((item, index) => (
//               <div
//                 key={index}
//                 className={`timeline-step ${item.completed ? 'completed' : ''} ${
//                   item.current ? 'current' : ''
//                 }`}
//               >
//                 <div className="step-icon" style={{ backgroundColor: item.bg }}>
//                   <item.icon size={14} color="white" />
//                 </div>
//                 <div className="step-details">
//                   <div className="step-title">{item.status}</div>
//                   <div className="step-time">{item.time}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         <section className="actions-section">
//           <h3>Need Help?</h3>
//           <div className="action-buttons">
//             <button className="action-btn problem">
//               <RiAlertTriangleLine size={16} />
//               Report Problem
//             </button>
//             <button className="action-btn">
//               <RiPhoneLine size={16} />
//               Contact Dispatch
//             </button>
//           </div>
//           <button className="emergency-btn">
//             <RiAlertTriangleLine size={16} />
//             Emergency Contact
//           </button>
//         </section>

//         <section className="notes-section">
//           <h3>Delivery Notes</h3>
//           <p className="notes">
//             Customer prefers front porch drop-off. Gate code: 4729. Please knock twice.
//           </p>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default DeliveryDetail;